import { render, staticRenderFns } from "./SubFlowProp.vue?vue&type=template&id=5647fba4&scoped=true"
import script from "./SubFlowProp.vue?vue&type=script&lang=js"
export * from "./SubFlowProp.vue?vue&type=script&lang=js"
import style0 from "./SubFlowProp.vue?vue&type=style&index=0&id=5647fba4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5647fba4",
  null
  
)

export default component.exports